<!-- eslint-disable -->
<template>
  <el-drawer title="选择车辆" destroy-on-close append-to-body :visible.sync="visible" v-if="visible" size="960px">
    <div class="select-view-container">
      <div class="item-container select-unselect-container" v-if="!pure">
        <!-- <div class="header-container">header-container</div> -->
        <div class="filter-container">
          <el-input v-model="keyword" placeholder="请输入车牌号" @input="handlerKeywordInput" />
        </div>
        <div class="view-container">
          <template v-if="options?.length">
            <el-checkbox
              v-for="item in options"
              :key="item.value"
              :name="item.value"
              class="checkbox-item"
              :value="judgeChecked(item)"
              @change="checkboxChange($event, item)"
            >
              <span class="checkbox-title">{{ item.label }}</span>
            </el-checkbox>
          </template>
          <div v-else class="el-empty">暂无数据</div>
        </div>
      </div>
      <div class="item-container select-select-container">
        <div class="header-container">已选择: {{ selectedOptions.length }}</div>
        <!-- <div class="filter-container">filter-container</div> -->
        <div class="view-container">
          <template v-if="selectedOptions?.length">
            <div class="list-item" v-for="item in selectedOptions" :key="item.value">
              <div class="list-item-label">{{ item.label }}</div>
              <div class="list-item-clear" @click="deleteSelected(item)" v-if="!pure">
                <i class="el-icon-close" style="font-size: 10; color: #505762"></i>
              </div>
            </div>
          </template>
          <div v-else class="el-empty">暂无数据</div>
        </div>
      </div>
    </div>
    <div class="drawer-configuration-footer">
      <el-button @click="handlerClose"> 取 消 </el-button>
      <el-button type="primary" @click="handlerConfirm" v-if="!pure"> 确 定 </el-button>
    </div>
  </el-drawer>
</template>
<script>
import { getVehiclePageNew } from '@/api/capacityManagement';
import { debounce } from 'lodash';

/* eslint-disable */
export default {
  name: 'SelectCar',
  components: {},
  data() {
    return {
      keyword: null,
      visible: false,
      options: [],
      selectedOptions: [],
    };
  },
  props: {
    pure: {
      type: Boolean,
      default: false,
    },
  },
  created() {},
  methods: {
    deleteSelected(item) {
      const index = this.selectedOptions?.findIndex((sitem) => sitem.value === item.value);
      if (index !== -1) {
        this.selectedOptions?.splice(index, 1);
      }
    },
    judgeChecked(item) {
      const index = this.selectedOptions?.findIndex((sitem) => sitem.value === item.value);
      return index !== -1;
    },
    checkboxChange(isChecked, item) {
      const index = this.selectedOptions?.findIndex((sitem) => sitem.value === item.value);
      if (isChecked) {
        if (index === -1) {
          this.selectedOptions?.push(item);
        }
      } else {
        if (index !== -1) {
          this.selectedOptions?.splice(index, 1);
        }
      }
    },
    async handlerSearchFn() {
      if (this.keyword) {
        const data = await getVehiclePageNew({ licensePlate: this.keyword });
        const result = data?.records?.map((item) => {
          return {
            value: item.licensePlate,
            label: item.licensePlate,
          };
        });
        this.options = result;
      }
    },
    handlerKeywordInput: debounce(async function () {
      this.handlerSearchFn();
    }, 200),
    async show({ selected, options: optionsItems } = {}) {
      this.keyword = null;
      this.selectedOptions = selected || [];
      this.options = optionsItems || [];
      this.visible = true;
    },
    handlerClose() {
      this.visible = false;
    },
    handlerConfirm() {
      this.$emit('confirm', this.selectedOptions);
      this.visible = false;
    },
  },
};
</script>
<style scoped lang="scss">
.drawer-configuration-footer {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 56px;
  border-top: 1px solid #ebeef5;
  width: 100%;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 24px;
  background-color: #fff;
}
.select-view-container {
  position: relative;
  background-color: var(--el-color-dark-bg);
  display: flex;
  width: 100%;
  padding: 0;
  border: 1px solid var(--el-border-color-light, #e6eaf0);
  box-sizing: border-box;
  border-radius: 4px;
  height: calc(100% - 68px);
  min-height: 376px;
  .item-container {
    // width: 50%;
    flex: 1;
    flex-grow: 1;
    flex-shrink: 0;
    box-sizing: border-box;
    // border-right: 1px solid var(--el-border-color-light, #e6eaf0);
    display: flex;
    flex-direction: column;
    .header-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      box-sizing: border-box;
      flex-shrink: 0;
      padding: 0 16px;
      height: 52px;
    }
    .filter-container {
      display: flex;
      align-items: center;
      height: 52px;
      flex-shrink: 0;
      box-sizing: border-box;
      margin: 0 16px;
    }
    .view-container {
      flex-grow: 1;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 0 8px;
      :deep(.el-empty) {
        color: rgba(0, 0, 0, 0.25);
        display: flex;
        height: 90%;
        align-items: center;
        justify-content: center;
      }
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 4px;
      }
      .checkbox-item {
        display: flex;
        width: 100%;
        font-size: 14px;
        color: var(--el-text-color-regular);
        box-sizing: border-box;
        padding: 0 8px;
        height: auto;
        min-height: 32px;
        align-items: center;
        &:hover {
          background-color: var(--el-border-color-lighter, #f0f2f5);
          border-radius: 4px;
        }
      }
      .checkbox-title {
        width: 100%;
        display: inline-block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        position: relative;
      }
    }
  }
}
.select-unselect-container {
  border-right: 1px solid var(--el-border-color-light, #e6eaf0);
}
.select-select-container {
  .list-item {
    font-size: 14px;
    color: var(--el-text-color-primary);
    display: flex;
    height: 34px;
    align-items: center;
    justify-content: space-between;
    padding: 0 8px;
    box-sizing: border-box;
    cursor: pointer;
    .list-item-label {
      width: 88%;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
      overflow: hidden;
    }
    .list-item-clear {
      width: 24px;
      height: 24px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      flex-shrink: 0;
    }
    &:hover {
      background-color: var(--el-border-color-lighter, #f0f2f5);
      .list-item-clear {
        background-color: var(--el-border-color-light, #e6eaf0);
      }
    }
  }
}
</style>
